import { Helmet } from 'react-helmet-async';
import { useEffect, useState, useMemo, useContext } from 'react';
// @mui
import {
  Stack,
  Card,
  Container,
  Avatar,
  Typography,
  Grid
} from '@mui/material';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { id } from "date-fns/locale";
import { format, parseISO } from 'date-fns';
import MUIDataTable from "mui-datatables";
import { TableLoader } from '../../components/table';
import { getCurrentDate, customDate, dateDiff } from "../../utils/formatDate";
// API
import { axiosPrivate } from '../../common/axiosPrivate';
import AuthContext from '../../context/authContext';

export default function CabangPegawaiPage() {
  const { user } = useContext(AuthContext);
  const [data, setData] = useState([]);
  const [tableLoading, setTableLoading] = useState(true);
  const BodyComponent = useMemo(
    () => (props) => (
      <TableLoader loading={tableLoading} {...props} />
    ),
    [tableLoading]
  );

  const columns = [
    {
      name: "number",
      label: "No",
      options: {
        filter: false,
        sort: false,
        customBodyRender : (value, tableMeta) => {
          const rowIndex = Number(tableMeta.rowIndex) + 1;
          return rowIndex;
        }
      },
    },
    {
      name: "nama",
      label: "Nama",
      options: {
      filter: false,
      sort: true,
      customBodyRender: (nama, meta) => {
        const profilUrlId = meta.rowData[15];
        const profilUrl = profilUrlId ? `https://drive.google.com/thumbnail?id=${profilUrlId}` : '';
        return (
          <Stack direction="row" alignItems="center" spacing={2}>
            <Avatar alt={profilUrl} src={profilUrl} imgProps={{ referrerPolicy: "no-referrer" }} />
            <Typography variant="subtitle2" noWrap>
              {nama}
            </Typography>
          </Stack>
        )
      }
      }
    },
    {
      name: "namaTanpaGelar",
      label: "Nama Tanpa Gelar",
      options: {
        filter: false,
        sort: false,
        display: false,
        viewColumns: false,
      }
    },
    {
     name: "kodePegawai",
     label: "Kode Pegawai",
     options: {
      filter: false,
      sort: true,
     }
    },
    {
     name: "jenisKelamin",
     label: "Jenis Kelamin",
     options: {
      filter: true,
      sort: false,
     }
    },
    {
     name: "kantor",
     label: "Kantor",
     options: {
      filter: true,
      sort: false,
     }
    },
    {
      name: "statusPegawai",
      label: "Status Pegawai",
      options: {
        filter: true,
        sort: false,
      }
    },
    {
      name: "jabatan",
      label: "Jabatan",
      options: {
       filter: true,
       sort: false,
      }
     },
    {
      name: "tglMasuk",
      label: "Tgl Masuk",
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value) => Object.prototype.toString.call(value) ? format(parseISO(value), 'dd/MM/yyyy') : format(new Date(value), 'dd/MM/yyyy'),
        filterType: 'custom',
        customFilterListOptions: {
          render: v => {
            if (v[0] && v[1]) {
              const startDate = format(new Date(v[0]), 'dd/MM/yyyy');
              const enDate = format(new Date(v[1]), 'dd/MM/yyyy');

              return [`Masuk Dari: ${startDate}`, `Sampai Dengan: ${enDate}`];
            } if (v[0]) {
              const startDate = format(new Date(v[0]), 'dd/MM/yyyy');

              return `Masuk Dari: ${startDate}`;
            } if (v[1]) {
              const enDate = format(new Date(v[1]), 'dd/MM/yyyy');

              return `Sampai Dengan: ${enDate}`;
            }
            return [];
          },
          update: (filterList, filterPos, index) => {
            if (filterPos === 0) {
              filterList[index].splice(filterPos, 1, '');
            } else if (filterPos === 1) {
              filterList[index].splice(filterPos, 1);
            } else if (filterPos === -1) {
              filterList[index] = [];
            }

            return filterList;
          },
        },
        filterOptions: {
          fullWidth: true,
          names: [],
          logic(date, filters) {
            const formated = new Date(customDate(date));

            if (filters[0] && filters[1]) {
              return !(formated >= filters[0] && formated <= filters[1]);
            }
            return false;
          },
          display: (filterList, onChange, index, column) => (
            <>
              <Grid container spacing={3} >
                <Grid item xs={12} sm={6}>
                  <LocalizationProvider adapterLocale={id} dateAdapter={AdapterDateFns}>
                    <DatePicker
                      label="Masuk Dari"
                      value={filterList[index][0] || null}
                      onChange={date => {
                        filterList[index][0] = date;
                        onChange(filterList[index], index, column);
                      }}
                      slotProps={{
                        textField: {
                          fullWidth: true,
                          variant: 'standard'
                        },
                        actionBar: { actions: ['clear'] },
                      }}
                    />
                </LocalizationProvider>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <LocalizationProvider adapterLocale={id} dateAdapter={AdapterDateFns}>
                    <DatePicker
                      label="Sampai Dengan"
                      value={filterList[index][1] || null}
                      onChange={date => {
                        filterList[index][1] = date;
                        onChange(filterList[index], index, column);
                      }}
                      slotProps={{
                        textField: {
                          fullWidth: true,
                          variant: 'standard'
                        },
                        actionBar: { actions: ['clear'] },
                      }}
                    />
                  </LocalizationProvider>
                </Grid>
              </Grid>
            </>
          ),
        },
      }
    },
    {
      name: "tglMasuk",
      label: "Lama Kerja",
      options: {
        filter: false,
        sort: true,
        customBodyRender: (value) => getDateDiff(format(parseISO(value), 'yyyy-MM-dd'), getCurrentDate('-'))
      }
    },
    {
      name: "tglStatus",
      label: "Tgl PKWTT",
      options: {
        filter: false,
        sort: false,
        display: false,
        customBodyRender: (value) => value ? format(parseISO(value), 'dd/MM/yyyy') : ''
      }
    },
    {
      name: "tglMulaiKontrak",
      label: "Tgl Mulai Kontrak",
      options: {
        filter: false,
        sort: false,
        display: false,
        customBodyRender: (value) => value ? format(parseISO(value), 'dd/MM/yyyy') : ''
      }
    },
    {
      name: "tglAkhirKontrak",
      label: "Tgl Akhir Kontrak",
      options: {
        filter: false,
        sort: false,
        display: false,
        customBodyRender: (value) => value ? format(parseISO(value), 'dd/MM/yyyy') : ''
      }
    },
    {
      name: "kontrakMagangKe",
      label: "Magang Ke",
      options: {
        filter: false,
        sort: true,
        display: false
      }
    },
    {
      name: "kontrakPkwtKe",
      label: "PKWT Ke",
      options: {
        filter: false,
        sort: true,
        display: false
      }
    },
    {
      name: "profilUrlId",
      label: "Google Drive Photo ID",
      options: {
        filter: false,
        sort: false,
        display: false,
        viewColumns: false
      }
    },
     // Hidden Columns
    {
      name: "tempatLahir",
      label: "Tempat Lahir",
      options: {
        filter: false,
        sort: false,
        display: false
      }
    },
    {
      name: "tglLahir",
      label: "Tgl Lahir",
      options: {
        filter: false,
        sort: false,
        display: false,
        customBodyRender: (value) => value ? format(parseISO(value), 'dd/MM/yyyy') : ''
      }
    },
    {
      name: "statusPerkawinan",
      label: "Status Perkawinan",
      options: {
        filter: false,
        sort: false,
        display: false
      }
    },
    {
      name: "pendidikan",
      label: "Pendidikan",
      options: {
        filter: false,
        sort: false,
        display: false
      }
    },
    {
      name: "agama",
      label: "Agama",
      options: {
        filter: false,
        sort: false,
        display: false
      }
    },
    {
      name: "ukuranBaju",
      label: "Ukuran Baju",
      options: {
        filter: false,
        sort: true,
        display: false
      }
    },
    {
      name: "kecamatan",
      label: "Kecamatan",
      options: {
        filter: false,
        sort: false,
        display: false
      }
    },
    {
      name: "kotaKabupaten",
      label: "Kota Kabupaten",
      options: {
        filter: false,
        sort: false,
        display: false
      }
    },
    {
      name: "alamat",
      label: "Alamat",
      options: {
        filter: false,
        sort: false,
        display: false,
        customBodyRender: (value) => value ? value.trim() : ''
      }
    },
    {
      name: "kecamatanDomisili",
      label: "Kecamatan Domisili",
      options: {
        filter: false,
        sort: false,
        display: false
      }
    },
    {
      name: "kotaKabupatenDomisili",
      label: "Kota Kabupaten Domisili",
      options: {
        filter: false,
        sort: false,
        display: false
      }
    },
    {
      name: "alamatDomisili",
      label: "Alamat Domisili",
      options: {
        filter: false,
        sort: false,
        display: false,
        customBodyRender: (value) => value ? value.trim() : ''
      }
    },
    {
      name: "noRekening",
      label: "No. Rekening",
      options: {
        filter: false,
        sort: false,
        display: false
      }
    },
    {
      name: "noHp",
      label: "No. Hp",
      options: {
        filter: false,
        sort: false,
        display: false
      }
    },
    {
      name: "noDarurat",
      label: "No. Darurat",
      options: {
        filter: false,
        sort: false,
        display: false
      }
    },
    {
      name: "nik",
      label: "NIK",
      options: {
        filter: false,
        sort: false,
        display: false
      }
    },
    {
      name: "npwp",
      label: "NPWP",
      options: {
        filter: false,
        sort: false,
        display: false
      }
    },
    {
      name: "bpjs",
      label: "BPJS",
      options: {
        filter: false,
        sort: false,
        display: false
      }
    },
    {
      name: "email",
      label: "Email",
      options: {
        filter: false,
        sort: false,
        display: false
      }
    },
    {
      name: "integritas",
      label: "Integritas",
      options: {
        filter: false,
        sort: false,
        display: false,
        customBodyRender: (value) => value ? 'Ya' : 'Tidak'
      }
    }, // End Hidden Columns
  ];
   
  const options = {
    filterType: "dropdown",
    selectableRowsHideCheckboxes: true,
    downloadOptions: {
      filename: `pegawai-${getCurrentDate('-')}.csv`,
      filterOptions: {
        useDisplayedColumnsOnly: false,
        useDisplayedRowsOnly: true,
      }
    }
  };

  const getDateDiff = (startDate, endDate) => {
    const { years, months, days } = dateDiff(startDate, endDate);

    let result = '';
    if (years > 0) {
        result += `${years} Tahun `;
    }
    if (months > 0) {
        result += `${months} Bulan `;
    }
    if (days > 0) {
        result += `${days} Hari `;
    }

    return result.trim(); // Remove trailing space
  };

  // Fetch Api
  const params = useMemo(() => {
    if (user?.role === 'area') {
      return { kantorList: user?.kantorList || [] };
    }
    if (user?.kantor) {
      return { kantorList: [user.kantor] };
    }
    return {};
  }, [user?.role, user?.kantor, user?.kantorList]);

  useEffect(() => {
    setTableLoading(true);
    axiosPrivate.get('Pegawai', { params })
      .then((response) => setData(response?.data))
      .catch((error) => console.log(error))
      .finally(() => setTableLoading(false));
  }, [params]);

  return (
    <>
      <Helmet>
        <title> List Pegawai | Sip App </title>
      </Helmet>

      <Container>
        <Card>
          <MUIDataTable
            title="List Pegawai"
            data={data}
            columns={columns}
            options={options}
            components={{ TableBody: BodyComponent }}
          />
        </Card>
      </Container>
    </>
  );
}
